/**
 * Rejestr „który widok listy jest teraz wybrany" — most między przełącznikiem widoków nad listą
 * (`ConfigurableTable` → `useTableLayout`, stan w pamięci jednej instancji) a menu „Kreator ▾"
 * (`ListBuilderMenu`), które żyje obok tabeli w nagłówku strony i nie ma do tego stanu dostępu.
 *
 * Tabela zgłasza aktywny układ pod kluczem listy (tableId BEZ sufiksu `::layout-<id>`, czyli slug
 * kartoteki), menu czyta go w chwili kliknięcia i otwiera Kreator Listy na tym widoku
 * (`?layout=<id>`). Wpis znika przy odmontowaniu tabeli — powrót na listę później zaczyna od
 * widoku domyślnego, więc stary wybór nie może „przeciec" do kreatora. Właściciel wpisu (token)
 * chroni przed tym, że odmontowanie jednej instancji skasuje wpis innej tej samej listy.
 */

const FORCED_SUFFIX_RE = /::layout-[^:]+$/;

const activeByList = new Map<string, { layoutId: string; owner: symbol }>();

/** Klucz listy: tableId bez sufiksu wymuszonego układu. */
export function listLayoutKey(tableId: string): string {
  return tableId.replace(FORCED_SUFFIX_RE, '');
}

export function setActiveListLayout(tableId: string, layoutId: string, owner: symbol): void {
  activeByList.set(listLayoutKey(tableId), { layoutId, owner });
}

export function clearActiveListLayout(tableId: string, owner: symbol): void {
  const key = listLayoutKey(tableId);
  if (activeByList.get(key)?.owner === owner) activeByList.delete(key);
}

export function getActiveListLayout(tableId: string): string | null {
  return activeByList.get(listLayoutKey(tableId))?.layoutId ?? null;
}
